import { render, staticRenderFns } from "./PUploader.vue?vue&type=template&id=820aaaa0&"
import script from "./PUploader.vue?vue&type=script&lang=js&"
export * from "./PUploader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports